import { createMakeStyles } from "tss-react";

const { makeStyles: makeStyle } = createMakeStyles({ useTheme: () => { } });

export default makeStyle
